import { AloPlat } from '@/models/alo/AloPlat';
import { ItemPanier } from '@/models/alo/ItemPanier';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'PlatEditable'
})
export default class PlatEditable extends Vue {
  
  isEdited:boolean = false
  itemPanier:ItemPanier = new ItemPanier()

  public edit(itemPanier:ItemPanier) {
    this.isEdited = true
    this.itemPanier = itemPanier
  }
    
}
